package com.ijoin.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material.icons.outlined.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.ijoin.i18n.strings
import com.ijoin.ui.design.EventCardAccent
import com.ijoin.ui.design.EventCardAccentDark
import com.ijoin.ui.design.EventCardAccentSoft
import com.ijoin.ui.design.EventCardBackground
import com.ijoin.ui.design.EventCardOutline
import com.ijoin.ui.design.EventCardRailContent
import com.ijoin.ui.design.EventCardRailWidth

@Composable
fun SideNavigationRail(
    selectedTab: String,
    onTabSelected: (String) -> Unit,
    modifier: Modifier = Modifier,
    showAppStoreLinks: Boolean = false
) {
    val strings = strings()
    val itemColors = NavigationRailItemDefaults.colors(
        selectedIconColor = EventCardAccent,
        selectedTextColor = EventCardAccentDark,
        indicatorColor = EventCardAccentSoft,
        unselectedIconColor = EventCardRailContent,
        unselectedTextColor = EventCardRailContent
    )

    Surface(
        modifier = modifier
            .fillMaxHeight()
            .width(EventCardRailWidth),
        color = EventCardBackground,
        border = BorderStroke(1.dp, EventCardOutline),
        shape = RoundedCornerShape(0.dp)
    ) {
        NavigationRail(
            modifier = Modifier.fillMaxSize(),
            containerColor = Color.Transparent,
            contentColor = EventCardRailContent
        ) {
            Spacer(modifier = Modifier.height(16.dp))

            NavigationRailItem(
                selected = selectedTab == "home",
                onClick = { onTabSelected("home") },
                icon = {
                    Icon(
                        imageVector = if (selectedTab == "home") Icons.Filled.Home else Icons.Outlined.Home,
                        contentDescription = strings.home
                    )
                },
                label = { Text(strings.home) },
                colors = itemColors
            )

            NavigationRailItem(
                selected = selectedTab == "create",
                onClick = { onTabSelected("create") },
                icon = {
                    Icon(
                        imageVector = if (selectedTab == "create") Icons.Filled.Add else Icons.Outlined.Add,
                        contentDescription = strings.createEvent
                    )
                },
                label = {
                    Text(
                        text = strings.createEvent,
                        maxLines = 2,
                        textAlign = TextAlign.Center
                    )
                },
                colors = itemColors
            )

            NavigationRailItem(
                selected = selectedTab == "tickets",
                onClick = { onTabSelected("tickets") },
                icon = {
                    Icon(
                        imageVector = if (selectedTab == "tickets") Icons.Filled.ConfirmationNumber else Icons.Outlined.ConfirmationNumber,
                        contentDescription = strings.tickets
                    )
                },
                label = { Text(strings.tickets) },
                colors = itemColors
            )

            NavigationRailItem(
                selected = selectedTab == "profile",
                onClick = { onTabSelected("profile") },
                icon = {
                    Icon(
                        imageVector = if (selectedTab == "profile") Icons.Filled.Person else Icons.Outlined.Person,
                        contentDescription = strings.profile
                    )
                },
                label = { Text(strings.profile) },
                colors = itemColors
            )

            // Push app store links to bottom
            if (showAppStoreLinks) {
                Spacer(modifier = Modifier.weight(1f))
                AppStoreLinks(
                    modifier = Modifier.padding(bottom = 16.dp)
                )
            }
        }
    }
}
